import { createSlice } from '@reduxjs/toolkit'
import { setApiClientAuthToken } from '~/api/base'
import { AUTH_TOKEN } from '~/utils/constants'

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    authToken: localStorage.getItem(AUTH_TOKEN)
  },

  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },
    logout: (state) => {
      state.user = null
      state.authToken = null
      setApiClientAuthToken(null)
    },
    setAuthToken: (state, action) => {
      state.authToken = action.payload
      setApiClientAuthToken(state.authToken)
    }
  }
})

export const { setUser, logout, setAuthToken } = authSlice.actions

export default authSlice
